export const ROI_ALERT = 0;
export const ONW_ROI_ALERT=  0.2;
export const DEFAULT_BID_COMPARE = 0.0007;
export const BID_COMPARE_FACTOR = 1.4;


// WEBPACK FOOTER //
// ./src/scenes/ZeroPark/config.js